const EUROPEAN_TIMEZONES = [
  'Europe/Amsterdam',
  'Europe/Andorra',
  'Europe/Athens',
  'Europe/Belgrade',
  'Europe/Berlin',
  'Europe/Bratislava',
  'Europe/Brussels',
  'Europe/Bucharest',
  'Europe/Budapest',
  'Europe/Chisinau',
  'Europe/Copenhagen',
  'Europe/Dublin',
  'Europe/Gibraltar',
  'Europe/Guernsey',
  'Europe/Helsinki',
  'Europe/Isle_of_Man',
  'Europe/Istanbul',
  'Europe/Jersey',
  'Europe/Kaliningrad',
  'Europe/Kiev',
  'Europe/Lisbon',
  'Europe/Ljubljana',
  'Europe/London',
  'Europe/Luxembourg',
  'Europe/Madrid',
  'Europe/Malta',
  'Europe/Mariehamn',
  'Europe/Minsk',
  'Europe/Monaco',
  'Europe/Moscow',
  'Europe/Oslo',
  'Europe/Paris',
  'Europe/Podgorica',
  'Europe/Prague',
  'Europe/Riga',
  'Europe/Rome',
  'Europe/Samara',
  'Europe/San_Marino',
  'Europe/Sarajevo',
  'Europe/Simferopol',
  'Europe/Skopje',
  'Europe/Sofia',
  'Europe/Stockholm',
  'Europe/Tallinn',
  'Europe/Tirane',
  'Europe/Uzhgorod',
  'Europe/Vaduz',
  'Europe/Vatican',
  'Europe/Vienna',
  'Europe/Vilnius',
  'Europe/Volgograd',
  'Europe/Warsaw',
  'Europe/Zagreb',
  'Europe/Zaporozhye',
  'Europe/Zurich',
];

const EUROPEAN_LOCALES = [
  'de', 'fr', 'it', 'es', 'pt', 'nl', 'pl', 'ro', 'el', 'cs', 'hu', 'sv', 'fi', 'da', 'sk', 'bg', 'hr', 'sl', 'et', 'lv', 'lt', 'mt', 'ga', 'cy',
];

export function isEuropeanUser(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (EUROPEAN_TIMEZONES.includes(timezone)) {
      return true;
    }
  } catch (error) {
  }

  try {
    const locale = navigator.language || navigator.languages?.[0] || '';
    const languageCode = locale.split('-')[0].toLowerCase();
    if (EUROPEAN_LOCALES.includes(languageCode)) {
      return true;
    }
  } catch (error) {
  }

  return false;
}

export function getCurrencySymbol(): string {
  return isEuropeanUser() ? '€' : '$';
}

